export * from './updateLastDocumentPathElementWithIdSuffix';
